<template>
  <v-avatar
    size="35"
    color="teal"
    style="color: #ffffff; border: 1px solid white !important"
  >
    {{ initial }}
  </v-avatar>
</template>

<script>

export default {
    props: {
        firstName: String,
        lastName: String
    },
    computed: {
        initial() {
            const firstLetter = this.firstName.toUpperCase()[0];
            const lastLetter = this.lastName.toUpperCase()[0];
            return `${firstLetter}${lastLetter}`;
        }
    }
}
</script>
